import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
interface FilterProps {
  handleChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCallFilter: () => void;
  courseName?: string;
  menuBookName?: string;
}
function FilterAddCourse({ handleChangeName, onCallFilter, courseName, menuBookName }: FilterProps) {
  const { t } = useTranslation();
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('addApplicableCoursesModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Row} className="mb-3">
              <Col sm={3} className="d-flex align-items-center justify-content-end p-0">
                {t('addApplicableCoursesModal.menu_book_name')}：
              </Col>
              <Col sm={4} className="d-flex align-items-center text-center">
                <div style={{ minWidth: '160px' }}>
                  <Form.Control
                    onKeyDown={(e: any) => {
                      if (e.key === 'Enter') {
                        onCallFilter();
                      }
                    }}
                    name="menuBookName"
                    value={menuBookName}
                    type="text"
                    onChange={handleChangeName}
                  />
                </div>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Col sm={3} className="d-flex align-items-center justify-content-end p-0">
                {t('addApplicableCoursesModal.course_name')}：
              </Col>
              <Col sm={4} className="d-flex align-items-center text-center">
                <div style={{ minWidth: '160px' }}>
                  <Form.Control
                    name="courseName"
                    onKeyDown={(e: any) => {
                      if (e.key === 'Enter') {
                        onCallFilter();
                      }
                    }}
                    value={courseName}
                    type="text"
                    onChange={handleChangeName}
                  />
                </div>
              </Col>
              <Col sm={5} className="d-flex align-items-center justify-content-end p-0">
                <Button style={{ maxWidth: '80px' }} variant="primary" onClick={onCallFilter}>
                  {t('addApplicableCoursesModal.narrow_down')}
                </Button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {`${t('addApplicableCoursesModal.menu_book_name')} :`} {menuBookName !== '' ? menuBookName : '-'}
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {`${t('addApplicableCoursesModal.course_name')} :`} {courseName !== '' ? courseName : '-'}
                </Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default FilterAddCourse;
